__turbopack_context__.v({
  "colourFilterColourSpot": "styles-module__LmKEnW__colourFilterColourSpot",
  "colourFilterDropdownContents": "styles-module__LmKEnW__colourFilterDropdownContents",
  "colourFilterDropdownOptionContainer": "styles-module__LmKEnW__colourFilterDropdownOptionContainer",
  "colourFilterDropdownOptionLabel": "styles-module__LmKEnW__colourFilterDropdownOptionLabel",
  "colourFilterOptionLabelContainer": "styles-module__LmKEnW__colourFilterOptionLabelContainer",
  "greyBorder": "styles-module__LmKEnW__greyBorder",
});
